import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api/client';
import { Alert } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { GeneratePasswordAction } from '../../components/ui/GeneratePasswordAction';
import { useAuth } from '../../context/AuthContext';

export function ForceChangePasswordPage() {
  const { refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('La nueva contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('La nueva contraseña y su confirmación no coinciden.');
      return;
    }
    if (newPassword === currentPassword) {
      setError('La nueva contraseña debe ser distinta de la provisional.');
      return;
    }

    setLoading(true);
    try {
      await api.post<{ message: string }>('/api/account/change-password', {
        currentPassword,
        newPassword,
      });
      await refreshUser();
      navigate('/panel', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo cambiar la contraseña');
    } finally {
      setLoading(false);
    }
  }

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Cambia tu contraseña</h1>
        <p className="muted">
          Tu cuenta se creó con una contraseña provisional. Elige una nueva para continuar.
        </p>
        {error ? (
          <div style={{ marginTop: '1rem' }}>
            <Alert tone="danger">{error}</Alert>
          </div>
        ) : null}
        <form onSubmit={handleSubmit} autoComplete="off">
          <Input
            label="Contraseña provisional"
            type="password"
            autoComplete="current-password"
            required
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <Input
            label="Nueva contraseña"
            type="password"
            autoComplete="new-password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            hint="Mínimo 8 caracteres"
            showPasswordToggle
            labelAction={
              <GeneratePasswordAction
                onGenerate={(pwd) => {
                  setNewPassword(pwd);
                  setConfirmPassword(pwd);
                }}
              />
            }
          />
          <Input
            label="Repite la nueva contraseña"
            type="password"
            autoComplete="new-password"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button type="submit" loading={loading}>
            Guardar y continuar
          </Button>
        </form>
        <p className="auth-card__footer">
          <button
            type="button"
            onClick={handleLogout}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              color: 'inherit',
              font: 'inherit',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Cerrar sesión
          </button>
        </p>
      </div>
    </div>
  );
}
